// extracted by mini-css-extract-plugin
module.exports = {"createUserBtn":"User_createUserBtn__-SE-e"};